import { preloadImage } from '@/utilities/preload-image'
import '@/components/ModalRegister'

if (!customElements.get('upsell-dialog')) {
  customElements.define(
    'upsell-dialog',
    class extends HTMLElement {
      isSubscription = false

      connectedCallback() {
        this.isSubscription = this.hasAttribute('subscription')
        this.setupListeners()
        this.render()

        // Preload all variant images to avoid flicker on selection
        Array.from(this.querySelectorAll<HTMLElement>('select[name="id"] option'))
          .map(el => el.dataset.imageUrl)
          .filter((url): url is string => !!url)
          .forEach(preloadImage)
      }

      setupListeners() {
        Array.from(this.querySelectorAll('input[name="selling_plan"]')).forEach(el =>
          el.addEventListener('change', e => {
            const select = e.target as HTMLSelectElement
            if (!select) return

            this.isSubscription = !!select.value
            this.render()
          })
        )

        this.querySelector('select[name="id"]')?.addEventListener('change', () => {
          this.render()
        })
      }

      render() {
        // Subscription/Onetime toggle
        this.toggleAttribute('subscription', this.isSubscription)

        const selectedOption = this.querySelector<HTMLOptionElement>(
          'select[name="id"] option:checked'
        )

        // Dynamic pricing detail
        const subPrice = this.querySelectorAll('.subscription-price')
        const otpPrice = this.querySelectorAll('.onetime-price')

        if (selectedOption) {
          const otpPriceValue = selectedOption.dataset.otpPrice
          const subPriceValue = selectedOption.dataset.subPrice

          if (otpPriceValue) {
            otpPrice.forEach(el => (el.textContent = otpPriceValue ?? ''))
          }

          if (subPriceValue) {
            subPrice.forEach(el => (el.textContent = subPriceValue ?? ''))
          }

          // Dynamic variant image
          const imageUrl = selectedOption.dataset.imageUrl
          const imgEl = this.querySelector<HTMLImageElement>('img.product-image')
          if (imgEl && imageUrl) {
            imgEl.src = imageUrl
            imgEl.srcset = imageUrl
          }
        }
      }
    }
  )
}
